import React from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');
import AccessibleIcon from '../common/AccessibleIcon';
import CourseStatsView from './CourseStatsView';
import ChannelShareReport from './ChannelShareReport';
import Null from '../common/Null';

const propTypes = {
    channelId: PropTypes.number.isRequired,
    backHandler: PropTypes.func,
    heading: PropTypes.string,
    orgName: PropTypes.string,
    subViewToken: PropTypes.oneOf(Object.values(Globals.view_tokens.author_dash.channel_subviews.courseStats)),
    onChangeSubView: PropTypes.func.isRequired,
};

const defaultProps = {
    subViewToken: Globals.view_tokens.author_dash.channel_subviews.courseStats.COURSE,
    backHandler: null,
    heading: "",
    orgName: "",
};

const VIEWS = {
    [Globals.view_tokens.author_dash.channel_subviews.courseStats.COURSE]: {
        eventKey: Globals.view_tokens.author_dash.channel_subviews.courseStats.COURSE,
        displayName: "Course",
        component: CourseStatsView,
    },
    [Globals.view_tokens.author_dash.channel_subviews.courseStats.SHARE]: {
        eventKey: Globals.view_tokens.author_dash.channel_subviews.courseStats.SHARE,
        displayName: "Sharing",
        component: ChannelShareReport,
    },
};

function ChannelCourseStatsView (props) {
    let Component = Null;
    if (!props.subViewToken) {
        Component = VIEWS[Globals.view_tokens.author_dash.channel_subviews.courseStats.COURSE].component;
    }
    else if (VIEWS[props.subViewToken]) {
        Component = VIEWS[props.subViewToken].component;
    }

    function _onSelectTab(key) {
        props.onChangeSubView(key);
    }

    return (
        <div>
            <div className="channelHeadingFlex">
                <div className="channelHeadingFlex__heading">
                    {(!!props.backHandler) &&

                            <button
                                className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                                onClick={props.backHandler}
                                title={Strings['en'].common.BACK}
                            >
                                <AccessibleIcon label={Strings['en'].common.BACK}>
                                    <span className="fa fa-chevron-left" aria-hidden={true}/>
                                </AccessibleIcon>
                            </button>
                    }
                    <h1 className="heading-lg">{props.heading}</h1>
                </div>
            </div>
            <div className="float-clear"/>
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse>
                    <Nav
                        justify
                        variant="tabs"
                        role="tablist"
                        defaultActiveKey={Globals.view_tokens.author_dash.channel_subviews.courseStats.COURSE}
                        activeKey={props.subViewToken}
                        onSelect={_onSelectTab}
                    >
                        {Object.values(VIEWS).map((view) => (
                            <Nav.Link key={view.eventKey} eventKey={view.eventKey}>
                                {view.displayName}
                            </Nav.Link>
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <div className="container-fluid padding-lr-xl margin-top-xl" role="tabpanel" aria-expanded="true">
                <Component className="tile-dash-floating" {...props} />
            </div>
        </div>
    )
}

ChannelCourseStatsView.propTypes = propTypes;
ChannelCourseStatsView.defaultProps = defaultProps;

export default ChannelCourseStatsView;
